<template>
  <div style="height: calc(100% + 120px">
    <SummaryBarChart :data="data" title="commission" label="commission" key="comission" />
  </div>
</template>

<script>
import SummaryBarChart from '@/components/smartDashboard/SummaryBarChart.vue';
import DashboardResume from '@/services/DashboardResume';
export default {
  name: 'BarChartCard',
  components: {
    SummaryBarChart
  },
  data() {
    return {
      data: []
    };
  },
  mixins: [DashboardResume],
  methods: {
    async getMonthsData() {
      try {
        this.onLoading(true);
        const { data } = await this.getAffiliateMonthlyCommissionResume('');
        this.data = data;
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  },
  created() {
    this.getMonthsData();
  }
};
</script>

<style></style>
